export default __webpack_public_path__ + "static/media/fbi.17098114.png";